import AsyncSelect from 'Shared/components/AsyncSelect'
import MenuListWithFooter from 'Shared/components/MenuListWithFooter'
import Step from './DashboardBuilderStep'
import { useAct } from 'DashboardBuilder/store'

export function AudienceShortDescriptor() {
  const {
    search,
    searchId,
    autoRefreshSearch
  } = useSel((s) => s.dashboard)

  const { searchCount } = useSel((s) => s.search)
  const complete = searchId !== null && search !== null

  if (!complete){
    return <p className='incomplete no-margin-bottom'>Who is included in this dashboard?</p>
  }

  return (
    <p className='no-margin-bottom audience-description'>
      This dashboard displays data for people in the <span className="bold">{search?.name}</span> audience 
      {searchCount && <> ({(searchCount || 0).toLocaleString()} members)</>},
      updating {autoRefreshSearch ? 'automatically every hour' : 'manually'}.
    </p>
  )
}

export default function Audience() {
  const act = useAct()
  const {
    id,
    searchId,
    autoRefreshSearch
  } = useSel((s) => s.dashboard)
  const adminUrl = window.location.pathname
  const newSearchPath = `/admin/searches/new?returning_url=${adminUrl}&linked_dashboard_id=${id}`

  function loadCount() {
    act.search.loadCount(searchId).then(({ data: { recalculating } }) => {
      if (recalculating) {
        setTimeout(() => {
          loadCount()
        }, 2500)
      }
    })
  }

  useEffect(() => {
    if (searchId) {
      loadCount()
    }
  }, [searchId])

  return (
    <div className="fields">
      <div className="row">
        <div className="column remaining">
          <div className="field">
            <label>Audience Included</label>
            <AsyncSelect
              entity="search"
              value={searchId}
              components={{ MenuList: MenuListWithFooter }}
              redirectUrl={newSearchPath}
              queryParameters={{
                activeOnly: true,
                excludeTemplates: true,
              }}
              onChange={(v) => act.dashboard.upsert({ searchId: v })}
            />
          </div>

          <div className="field margin-top half">
            <label>When should this audience update?</label>
            <select className="margin-bottom half" value={autoRefreshSearch ? 'true' : 'false'} onChange={(e) => act.dashboard.upsert({ autoRefreshSearch: e.target.value === 'true' })}>
              <option value="true">Update the audience every hour</option>
              <option value="false">Only update the audience if I choose to</option>
            </select>
            <small>When the audience updates it pulls in new people who match the audience, and removes people who no longer match</small>
          </div>
        </div>
      </div>
    </div>
  )
}
